import { render, staticRenderFns } from "./KETManageRabatte.vue?vue&type=template&id=481f2390&"
import script from "./KETManageRabatte.vue?vue&type=script&lang=js&"
export * from "./KETManageRabatte.vue?vue&type=script&lang=js&"
import style0 from "./KETManageRabatte.vue?vue&type=style&index=0&id=481f2390&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports